function initSlideZoom() {
  console.log('Initializing slide zoom...');
  
  const slideshow = document.querySelector('#Slideshow-template--22546468077871__aba650b0-db22-45d1-8421-4c2d058a229e');
  
  if (!slideshow) {
    console.log('Slideshow not found');
    return;
  }

  function triggerZoom() {
    console.log('Triggering zoom animation...');
    
    // Remove animation from all slides
    const allSlides = slideshow.querySelectorAll('.slideshow__slide');
    allSlides.forEach(slide => {
      slide.classList.remove('add-animation');
    });

    // Add animation to current slide
    const currentSlide = slideshow.querySelector('.slideshow__slide.is-selected');
    if (currentSlide) {
      // Force reflow to ensure class removal takes effect
      currentSlide.offsetHeight;
      
      currentSlide.classList.add('add-animation');
      console.log('Animation class added to:', currentSlide);
      
      // Debug: Check if images exist
      const images = currentSlide.querySelectorAll('img');
      console.log('Images found in slide:', images.length);
    } else {
      console.log('No selected slide found');
    }
  }

  // Initial zoom
  setTimeout(triggerZoom, 1500);

  // Listen for dot clicks
  document.addEventListener('click', function(e) {
    if (e.target.matches('.flickity-page-dots .dot')) {
      console.log('Dot clicked');
      setTimeout(triggerZoom, 300);
    }
  });

  // For autoplay - simple interval that doesn't interfere
  let lastSlideIndex = -1;
  setInterval(function() {
    const currentSlide = slideshow.querySelector('.slideshow__slide.is-selected');
    if (currentSlide) {
      const currentIndex = parseInt(currentSlide.getAttribute('data-index')) || 0;
      if (currentIndex !== lastSlideIndex) {
        lastSlideIndex = currentIndex;
        triggerZoom();
      }
    }
  }, 500); // Check every 500ms
}

// Initialize
setTimeout(initSlideZoom, 2000);
